export default "__VITE_ASSET__CQ5XWzWI__"